import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

import ConnectivityTestModule from "./modules/connectivity";
import DevicesModule from "./modules/devices";

const state = () => ({
  defaultPublisher: null,

  /** Publisher controls */
  publisherAudioEnabled: true,
  publisherVideoEnabled: true,

  /** Subscriber controls */
  subscriberAudioEnabled: true,
  subscriberAudioLevel: 50
});

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    connectivity: ConnectivityTestModule,
    devices: DevicesModule
  }
};
